/* tslint:disable */
/* eslint-disable */
/**
 * API SPECS
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { InfantOneMonthOld } from './InfantOneMonthOld';
import {
    InfantOneMonthOldFromJSON,
    InfantOneMonthOldFromJSONTyped,
    InfantOneMonthOldToJSON,
} from './InfantOneMonthOld';
import type { PaginationInfo } from './PaginationInfo';
import {
    PaginationInfoFromJSON,
    PaginationInfoFromJSONTyped,
    PaginationInfoToJSON,
} from './PaginationInfo';

/**
 * 
 * @export
 * @interface InfantOneMonthOldPanigation
 */
export interface InfantOneMonthOldPanigation {
    /**
     * 
     * @type {Array<InfantOneMonthOld>}
     * @memberof InfantOneMonthOldPanigation
     */
    data?: Array<InfantOneMonthOld>;
    /**
     * 
     * @type {PaginationInfo}
     * @memberof InfantOneMonthOldPanigation
     */
    meta?: PaginationInfo;
}

/**
 * Check if a given object implements the InfantOneMonthOldPanigation interface.
 */
export function instanceOfInfantOneMonthOldPanigation(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function InfantOneMonthOldPanigationFromJSON(json: any): InfantOneMonthOldPanigation {
    return InfantOneMonthOldPanigationFromJSONTyped(json, false);
}

export function InfantOneMonthOldPanigationFromJSONTyped(json: any, ignoreDiscriminator: boolean): InfantOneMonthOldPanigation {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : ((json['data'] as Array<any>).map(InfantOneMonthOldFromJSON)),
        'meta': !exists(json, 'meta') ? undefined : PaginationInfoFromJSON(json['meta']),
    };
}

export function InfantOneMonthOldPanigationToJSON(value?: InfantOneMonthOldPanigation | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': value.data === undefined ? undefined : ((value.data as Array<any>).map(InfantOneMonthOldToJSON)),
        'meta': PaginationInfoToJSON(value.meta),
    };
}

